import React from 'react';
import voca from 'voca';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import showAlert from '../../../common/utils/alert';
import CopyToClipboard from 'react-copy-to-clipboard';
import { toast } from 'react-toastify';

export const CdnList = ({
  projectId,
  version,
  customComponentId,
  cdns,
  setCurrentCdn,
  setToggle,
  onDelete,
  isReadOnly,
}) => {
  const handleDelete = (cdnId) => {
    const preConfirm = () =>
      onDelete({ projectId, version, componentId: customComponentId, cdnId });
    showAlert("You won't be able to revert it!", preConfirm, 'Yes, delete it!');
  };

  const copyToClipboard = (urlOrTag) => {
    if (urlOrTag) toast.success('Copied to clipboard');
  };

  return (
    <div className="row mx-auto h-70 table-responsive mt-5">
      <table className="table table-bordered table-hover table-sm table-word-break">
        <thead>
          <tr>
            <th title="Index" className="w-10">
              #
            </th>
            <th title="URL/Tag" className="w-70">
              URL/Tag
            </th>
            <th title="Action">Action</th>
          </tr>
        </thead>
        <tbody>
          {cdns.map((cdn, index) => {
            return (
              <tr key={cdn.uuid} className="text-left">
                <td>{index + 1}</td>
                <td className="align-middle" title={cdn.urlOrTag}>
                  <CopyToClipboard
                    text={cdn.urlOrTag ? cdn.urlOrTag : ''}
                    onCopy={() => copyToClipboard(cdn.urlOrTag)}
                    title={'Copy to clipboard'}
                    style={{
                      cursor: 'pointer',
                      padding: '4px',
                      verticalAlign: 'middle',
                      margin: 0,
                    }}
                  >
                    <span>
                      {voca.first(cdn.urlOrTag, 40)}...
                      {voca.last(cdn.urlOrTag, 30)} <i className="webconnect webconnect-files" />
                    </span>
                  </CopyToClipboard>
                </td>
                <td className="text-right">
                  &nbsp;
                  <button
                    className="btn btn-xs btn-primary"
                    onClick={
                      isReadOnly
                        ? undefined
                        : () => {
                            setCurrentCdn(cdn);
                            setToggle(true);
                          }
                    }
                    title={isReadOnly ? 'Read-Only Mode' : 'Edit URL/Tag'}
                    disabled={isReadOnly}
                  >
                    <i className={`wb ${drapcodeIcon('edit')}`}></i>
                  </button>
                  &nbsp;
                  <button
                    className="btn btn-xs btn-theme-delete"
                    onClick={() => (isReadOnly ? undefined : handleDelete(cdn.uuid))}
                    title={isReadOnly ? 'Read-Only Mode' : 'Delete URL/Tag'}
                    disabled={isReadOnly}
                  >
                    <i className={`wb ${drapcodeIcon('delete')}`}></i>
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
